"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("@emotion/react");

var react_2 = __importStar(require("react"));

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_form_controls_1 = require("@ryerson/frontend.form-controls");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var polished_1 = require("polished");

var frontend_application_1 = require("@ryerson/frontend.application");

var gatsby_1 = require("gatsby");

var router_1 = require("@reach/router");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var loginForm_enum_1 = require("./loginForm.enum");

var closeButton = function closeButton(props) {
  return (0, react_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 50px;\n\theight: 50px;\n\tborder-left: 1px solid ", ";\n"])), (0, polished_1.rgba)(props.color, 0.1));
};

var closeButtonWrapper = function closeButtonWrapper(props) {
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tbackground-color: ", ";\n"])), props.isMobile && props.color);
};

var loginForm = function loginForm(props) {
  return (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 17.869px rgba(0, 0, 0, 0.0417275),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n\tposition: relative;\n\tz-index: 10;\n"])), props.background);
};

var mainContainerStyles = function mainContainerStyles(props) {
  return (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t@media only screen and (max-width: ", ") {\n\t\tleft: ", ";\n\t\twidth: 100%;\n\t\ttransition: left 0.3s linear;\n\t\tposition: absolute;\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;\n\t\tz-index: 999;\n\t\tdisplay: ", ";\n\t}\n"])), props.breakpoint, props.isActive ? "0%" : "-100%", props.isActive ? "block" : "none");
};

var LoginForm = function LoginForm(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      isMobile = _ref.isMobile,
      openLogin = _ref.openLogin,
      handleClose = _ref.handleClose;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      lighterGray = _theme$colors$primary.lighterGray,
      darkGray = _theme$colors$primary.darkGray,
      white = _theme$colors$primary.white;

  var _react_2$default$useS = react_2.default.useState(""),
      _react_2$default$useS2 = _slicedToArray(_react_2$default$useS, 2),
      userName = _react_2$default$useS2[0],
      setUserName = _react_2$default$useS2[1];

  var _react_2$default$useS3 = react_2.default.useState(""),
      _react_2$default$useS4 = _slicedToArray(_react_2$default$useS3, 2),
      password = _react_2$default$useS4[0],
      setPassword = _react_2$default$useS4[1];

  var _react_2$default$useS5 = react_2.default.useState(false),
      _react_2$default$useS6 = _slicedToArray(_react_2$default$useS5, 2),
      showPassword = _react_2$default$useS6[0],
      setShowPassword = _react_2$default$useS6[1];

  var _react_2$default$useS7 = react_2.default.useState(null),
      _react_2$default$useS8 = _slicedToArray(_react_2$default$useS7, 2),
      error = _react_2$default$useS8[0],
      setError = _react_2$default$useS8[1];

  var _ref3 = (0, frontend_application_1.useApplication)(),
      login = _ref3.login,
      language = _ref3.localization.language;

  var _ref4 = (0, frontend_e_commerce_1.useEcommerce)(),
      resetAllCheckoutInformation = _ref4.resetAllCheckoutInformation;

  var location = (0, router_1.useLocation)();
  var forgotPasswordUrl = openLogin && location && location.origin + "/login/forgot-password";

  var _ref5 = (0, react_2.useState)(""),
      _ref6 = _slicedToArray(_ref5, 2),
      bodyStyles = _ref6[0],
      setBodyStyles = _ref6[1];

  var _ref7 = (0, react_2.useState)(function () {
    var currVal = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.loginActive);
    return currVal === "true" ? true : false;
  }),
      _ref8 = _slicedToArray(_ref7, 2),
      isActive = _ref8[0],
      setIsActive = _ref8[1];

  (0, react_2.useEffect)(function () {
    var body = document === null || document === void 0 ? void 0 : document.querySelector("body");

    if (openLogin === true) {
      setIsActive(true);
      setBodyStyles((body === null || body === void 0 ? void 0 : body.getAttribute("style")) || "");
      sessionStorage.setItem(frontend_common_1.SessionItems.loginActive, "true");
    } else {
      setIsActive(false);
      sessionStorage.setItem(frontend_common_1.SessionItems.loginActive, "false");
    }

    return function () {
      body && body.setAttribute("style", bodyStyles);
    };
  }, [openLogin]);

  var onLoginClick = function onLoginClick() {
    if (userName && password) {
      var userLoginRequest = {
        username: userName,
        password: password
      };
      login(userLoginRequest).then(function (user) {
        setError(null);
        resetAllCheckoutInformation();
        handleClose(true);
      }).catch(function (error) {
        setError(error ? error.data : "error"); // TODO We should handle the different kinds of errors here and display messages accordingly.
      });
    }
  };

  var handleKeypress = function handleKeypress(e) {
    if (e.keyCode === 13) {
      onLoginClick();
    }
  };

  var handlePasswordVisibility = function handlePasswordVisibility() {
    setShowPassword(!showPassword);
  };

  var InvalidErrorMessage = function InvalidErrorMessage() {
    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      direction: "column",
      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        variant: "span",
        size: "sm",
        color: theme.colors.primary.secondaryBrand,
        children: frontend_common_1.CONSTANTS[language].AUTH_ERROR
      }), forgotPasswordUrl ? (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
        gatsby: true,
        type: "secondary",
        to: forgotPasswordUrl,
        size: "sm",
        children: "".concat(frontend_common_1.CONSTANTS[language].RESET_PASSWORD, " ?")
      }) : null]
    });
  };

  var LockOutErrorMessage = function LockOutErrorMessage() {
    return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      direction: "column",
      children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
        variant: "span",
        size: "sm",
        color: theme.colors.primary.secondaryBrand,
        children: ["".concat(frontend_common_1.CONSTANTS[language].LOCKOUT_LABEL1, " "), (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
          to: "".concat(window.location.origin, "/contact-us"),
          children: frontend_common_1.CONSTANTS[language].CONTACT_US
        }), frontend_common_1.CONSTANTS[language].LOCKOUT_LABEL2]
      })
    });
  };

  var ResetErrorMessage = function ResetErrorMessage() {
    return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      direction: "column",
      children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
        variant: "span",
        size: "sm",
        color: theme.colors.primary.secondaryBrand,
        children: [(0, jsx_runtime_1.jsx)("span", {
          children: "".concat(frontend_common_1.CONSTANTS[language].RESET_MESSAGE, " ")
        }), (0, jsx_runtime_1.jsxs)("div", {
          children: [(0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
            type: "secondary",
            to: forgotPasswordUrl || "/",
            size: "sm",
            children: "".concat(frontend_common_1.CONSTANTS[language].RESET_PASSWORD, " ")
          }), " ", frontend_common_1.CONSTANTS[language].RESET_MESSAGE2]
        })]
      })
    });
  };

  var renderErrorMessage = function renderErrorMessage() {
    switch (error) {
      case loginForm_enum_1.LoginErrorResponse.ContactSupport:
        return (0, jsx_runtime_1.jsx)(LockOutErrorMessage, {});

      case loginForm_enum_1.LoginErrorResponse.Reset:
        return (0, jsx_runtime_1.jsx)(ResetErrorMessage, {});

      default:
        return (0, jsx_runtime_1.jsx)(InvalidErrorMessage, {});
    }
  };

  return (0, jsx_runtime_1.jsx)("div", {
    css: mainContainerStyles({
      isActive: isActive,
      breakpoint: theme.breakpoints.lg
    }),
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: className,
      direction: "column",
      style: loginForm({
        background: lighterGray
      }),
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        justifyContent: "flex-end",
        style: closeButtonWrapper({
          color: darkGray,
          isMobile: isMobile
        }),
        children: isMobile && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          justifyContent: "center",
          alignItems: "center",
          style: closeButton({
            color: white,
            isMobile: isMobile
          }),
          onClick: function onClick() {
            return handleClose(true);
          },
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "close",
            size: "sm",
            onClick: function onClick() {
              return handleClose(true);
            },
            color: white
          })
        })
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
        css: {
          margin: "20px 20px 40px 20px",
          width: isMobile ? "auto" : "340px"
        },
        children: [isMobile && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h3",
          css: {
            marginBottom: 0,
            marginTop: "20px"
          },
          children: frontend_common_1.CONSTANTS[language].LOG_IN
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          alignItems: "center",
          style: (0, react_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\theight: ", ";\n\t\t\t\t\t\t\tmargin: ", ";\n\t\t\t\t\t\t"])), error ? "60px" : isMobile ? "14px" : 0, isMobile ? "10px 0" : "0 0 18px 0"),
          children: error && (0, jsx_runtime_1.jsxs)(react_2.default.Fragment, {
            children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
              icon: "exclamation",
              color: theme.colors.primary.accentBrand,
              circled: true,
              css: {
                marginRight: "8px",
                width: error === "Contact Support" ? "34px" : "24px"
              }
            }), renderErrorMessage()]
          })
        }), (0, jsx_runtime_1.jsx)(frontend_form_controls_1.Input, {
          label: frontend_common_1.withTranslation.username[language],
          placeholder: "",
          name: "username",
          id: "username",
          value: userName,
          onChange: function onChange(event) {
            return setUserName(event.target.value);
          },
          onKeyDown: handleKeypress,
          language: language,
          dataTestId: "login-username-input"
        }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(frontend_form_controls_1.Input, {
          label: frontend_common_1.withTranslation.password[language],
          inputType: showPassword ? "text" : "password",
          icon: showPassword ? "no-view" : "view",
          iconLabel: showPassword ? frontend_common_1.withTranslation.hide[language] : frontend_common_1.withTranslation.show[language],
          placeholder: "",
          name: "password",
          id: "password",
          value: password,
          onChange: function onChange(event) {
            return setPassword(event.target.value);
          },
          onKeyDown: handleKeypress,
          onIconClick: handlePasswordVisibility,
          language: language,
          dataTestId: "login-password-input"
        }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          justifyContent: "flex-end",
          css: {
            marginBottom: "40px"
          },
          children: forgotPasswordUrl ? (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
            gatsby: true,
            type: "secondary",
            to: forgotPasswordUrl,
            size: "sm",
            dataTestId: "login-forgot-password-link",
            children: "".concat(frontend_common_1.CONSTANTS[language].FORGOT_PASSWORD, "?")
          }) : null
        }), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          fullwidth: true,
          label: "Log In",
          onClick: onLoginClick,
          disabled: (userName && password) === "",
          dataTestId: "header-login-button"
        }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          fullwidth: true,
          type: "secondary",
          label: "Create an Account",
          onClick: function onClick() {
            (0, gatsby_1.navigate)(location && location.origin + "/register");
          },
          dataTestId: "header-create-an-account-button"
        })]
      })]
    })
  });
};

exports.default = LoginForm;